export default {
  selectData: [],
  sysConfig: []
}
